import { SortDirection } from '../../../../../../api/src/_core/utils/utils.paging';
import { Filter } from '../filter/filter.model';
import { FilterType } from '../../../../../../api/src/data-source/models/filter.model';

export const searchFilter = {
	id: 'search',
	name: 'Search',
	paramKey: 'search',
	type: FilterType.Search,
	prefixIcon: 'search',
	order: 0
} as Filter;

export const uploadDataSource = {
	id: "uploads",
	name: "Uploads",
	slug: "uploads",
	locale: {
		name: {
			["fr-CA"]: "Téléversements",
			["zh-CN"]: "上传",
			["zh-Hant"]: "上傳"
		}
	},
	config: {
		params: {
			sort: "created",
			sortStrategy: SortDirection.DESC
		},
		sortableFields: [
			{ path: "created", displayName: "Date" },
			{ path: "title", displayName: "Title" },
		],
		filters: [
			searchFilter
		]
	}
} as any;
